/**
 * @component FaqPage
 * @description 고객 문의 전 자주 묻는 질문을 빠르게 확인할 수 있도록 FAQ 아코디언 목록을 제공하는 페이지입니다.
 * @usage App 라우팅에서 `/cs/faq.html` 경로일 때 렌더링됩니다.
 */

import PageHero from '../../components/common/PageHero';
import SectionHeading from '../../components/common/SectionHeading';
import { pageMeta } from '../../constants/navigation';
import { faqItems } from '../../constants/supportData';
import { useFaqAccordion } from '../../hooks/useFaqAccordion';

export default function FaqPage({ onNavigate }) {
  // [상태 조회]: 현재 열려 있는 FAQ 항목과 토글 함수를 가져옵니다.
  const { expandedFaq, toggleFaq } = useFaqAccordion();

  return (
    <>
      <PageHero title={pageMeta.faq.title} trail={pageMeta.faq.trail} className="cs-page-hero" />
      <section className="section">
        <div className="container">
          <SectionHeading
            eyebrow="FAQ"
            title="자주 묻는 질문을 먼저 확인해보세요"
            description="도입 방식, 지원 범위, 상담 절차 등 자주 문의하시는 내용을 정리했습니다."
            className="fade-in"
          />

          <div className="faq-list">
            {faqItems.map((item) => {
              const isOpen = expandedFaq === item.question;

              return (
                <article key={item.question} className={`faq-card card-panel fade-in ${isOpen ? 'is-open' : ''}`}>
                  {/* [이벤트 처리]: 질문 버튼 클릭 시 해당 항목의 펼침/접힘 상태를 전환합니다. */}
                  <button type="button" className="faq-trigger" onClick={() => toggleFaq(item.question)} aria-expanded={isOpen}>
                    <span>{item.question}</span>
                    <strong>{isOpen ? '−' : '+'}</strong>
                  </button>
                  <div className={`faq-content ${isOpen ? 'is-open' : ''}`}>
                    <p>{item.answer}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
